class Popup {
	constructor (icon, body, button, buttonClickHandle ,additionalInfo, imageSrc) {
		this.icon = icon;
		this.body = body;
		this.button = button;
		this.buttonClickHandle = buttonClickHandle;
		this.additionalInfo = additionalInfo;
		this.imageSrc = imageSrc;
	}
	
	close() {
			$(".popup").remove();
	}

	build() {
		$('.popup').remove();
			$("<div>", {
				class: "popup"
			}).prepend(
				$("<div>", {
					class: "popup-content",
				}).append(
					$("<div>", {
						text: '✕'
					}).addClass("popup-close").click(this.close),
					$("<img>", {
						src: this.imageSrc
					}),
					$("<div>").addClass("popup-content-holder").append(
						$("<span>", {
							text: this.body
						}),
						$("<button>", {
							text: this.button
						}).addClass("join white-button").click((e) => this.buttonClickHandle(e, this.body())),
						$("<span>", {
							text: this.additionalInfo
						})
					)
				)
			).appendTo("body")
	}
}
